const Footer = () => {
    return (
        <footer>
            <div className="wrap">
                <div className="foot-top">
                    <div className="foot-brand">
                        <div className="bn">VINEWOOD</div>
                        <p>Server românesc de RPG pe GTA V, construit cu pasiune pe FiveM.</p>
                    </div>
                    <div className="foot-cols">
                        <div className="foot-col">
                            <h4>Platformă</h4>
                            <a href="https://panel.vinewood.ro/">UCP</a>
                            <a href="https://wiki.vinewood.ro/">Wiki</a>
                            <a href="https://panel.vinewood.ro/">Forum</a>
                            <a href="https://panel.vinewood.ro/">Shop</a>
                        </div>
                        <div className="foot-col">
                            <h4>Social</h4>
                            <a href="https://discord.com/invite/8Uw4wjc7nW">Discord</a>
                            <a href="https://www.youtube.com/@vinewoodmp">YouTube</a>
                            <a href="https://tiktok.com/@vinewood.mp">TikTok</a>
                            <a href="https://instagram.com/vinewood.mp">Instagram</a>
                        </div>
                    </div>
                </div>
                <div className="foot-bot">
                    <p>© {new Date().getFullYear()} Vinewood Multiplayer. Toate drepturile rezervate.</p>
                    <p className="legal">GRAND THEFT AUTO AND GRAND THEFT AUTO: V ARE REGISTERED TRADEMARKS OF TAKE-TWO INTERACTIVE SOFTWARE. WE ARE NOT AFFILIATED WITH OR ENDORSED BY TAKE-TWO INTERACTIVE SOFTWARE.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
